// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedCurrency from "@insite/content-library/Components/LocalizedCurrency";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { orderSummaryProps } from "@store/Themes/common/props/order";
import constants from "@store/constants";
import { useInvoicePaymentContext } from "@store/Framework/Components/InvoicePaymentContext/InvoicePaymentContext";
import React, { FC } from "react";

export interface InvoicePaymentSummaryProps extends WidgetProps {}

export interface InvoicePaymentSummaryStyles {
    wrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    itemWrapper?: InjectableCss;
    totalLabel?: TypographyPresentationProps;
    totalValue?: TypographyPresentationProps;
}

export const invoicePaymentSummaryStyles: InvoicePaymentSummaryStyles = {
    wrapper: orderSummaryProps.wrapper,
    titleWrapper: orderSummaryProps.titleWrapper,
    title: orderSummaryProps.title,
    itemWrapper: orderSummaryProps.itemWrapper,
    totalLabel: orderSummaryProps.itemLabel,
    totalValue: orderSummaryProps.itemValue,
};

const styles = invoicePaymentSummaryStyles;

const InvoicePaymentSummary: FC<InvoicePaymentSummaryProps> = () => {
    const { invoices, termDiscount, total, paymentSuccess } = useInvoicePaymentContext();

    if (!invoices) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.titleWrapper}>
                <Typography {...styles.title}>{translate("Payment Summary")}</Typography>
            </StyledWrapper>
            {paymentSuccess ? (
                <>
                    <StyledWrapper {...styles.itemWrapper}>
                        <Typography {...styles.totalLabel}>{translate("Charged amount")}</Typography>
                        <Typography {...styles.totalValue}>
                            <LocalizedCurrency amount={paymentSuccess.amount} />
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.itemWrapper}>
                        <Typography {...styles.totalLabel}>{translate("Confirmation code")}</Typography>
                        <Typography {...styles.totalValue}>{paymentSuccess.authorizationCode}</Typography>
                    </StyledWrapper>
                </>
            ) : (
                <>
                    <StyledWrapper {...styles.itemWrapper}>
                        <Typography {...styles.totalLabel}>
                            {translate("grimco_invoice_history_selected_discount")}
                        </Typography>
                        <Typography {...styles.totalValue}>
                            <LocalizedCurrency amount={termDiscount} />
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.itemWrapper}>
                        <Typography {...styles.totalLabel}>{translate("Total")}</Typography>
                        <Typography {...styles.totalValue}>
                            <LocalizedCurrency amount={total} />
                        </Typography>
                    </StyledWrapper>
                </>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: InvoicePaymentSummary,
    definition: {
        group: constants.widgetGroup.invoicePayment,
        displayName: "Summary",
        allowedContexts: [constants.pageType.invoicePayment],
    },
};

export default widgetModule;
